import axiosInstanceNew from "../lib/axiosinstanceNew";

const ClassLinkingModal = class {

   
    async Get(id,iid){
        return(
            await axiosInstanceNew.get(`level_linking?class_id=${id}&subject_id=${iid}`)
        )
    }
    async GetbySubject(id){
        return(
            await axiosInstanceNew.get(`level_linking?subject_id=${id}`)
        )
    }
    async GetAll(id,iid){
        return(
            await axiosInstanceNew.get(`level_linking`)
        )
    }
    async add(data= []){
        return(
            await axiosInstanceNew.post(`level_linking`,data)
        )
    }
    async delete(id){
        return(
            await axiosInstanceNew.delete(`level_linking/${id}`)
        )
    }
}
export default new ClassLinkingModal();